import React, { useEffect, useState, useRef } from 'react';
import './Modal.css';
import './ModalInnovation.css';

function ModalInnovation({ data, show, onClose, allowFullscreen = false, small = false, showImage = true }) {
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [isDragging, setIsDragging] = useState(false);
    const [position, setPosition] = useState(null);
    const modalRef = useRef(null);
    const dragStartRef = useRef({ x: 0, y: 0 });

    const handleMouseDown = (e) => {
        if (e.target.closest('.modalclose') || isFullScreen) {
            return;
        }

        const modalRect = modalRef.current.getBoundingClientRect();
        setIsDragging(true);

        dragStartRef.current = {
            x: e.clientX - modalRect.left,
            y: e.clientY - modalRect.top
        };

        // Set initial position to current position
        setPosition({
            x: modalRect.left,
            y: modalRect.top
        });
    };

    const handleMouseMove = (e) => {
        if (isDragging && !isFullScreen) {
            const newX = e.clientX - dragStartRef.current.x;
            const newY = e.clientY - dragStartRef.current.y;

            // Prevent dragging outside viewport
            const modalRect = modalRef.current.getBoundingClientRect();
            const maxX = window.innerWidth - modalRect.width;
            const maxY = window.innerHeight - modalRect.height;

            setPosition({
                x: Math.min(Math.max(0, newX), maxX),
                y: Math.min(Math.max(0, newY), maxY)
            });
        }
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    useEffect(() => {
        if (isDragging) {
            window.addEventListener('mousemove', handleMouseMove);
            window.addEventListener('mouseup', handleMouseUp);
            document.body.style.userSelect = 'none';
        } else {
            document.body.style.userSelect = '';
        }
        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
            document.body.style.userSelect = '';
        };
    }, [isDragging]);

    const toggleFullScreen = () => {
        setIsFullScreen(!isFullScreen);
        setPosition(null);
    };

    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };
        window.addEventListener('keydown', handleEscape);
        return () => window.removeEventListener('keydown', handleEscape);
    }, [onClose]);

    // Reset position when modal is shown
    useEffect(() => {
        if (show) {
            setPosition(null);
            setIsFullScreen(false);
        }
    }, [show]);

    if (!show) return null;

    return (
        <div
            ref={modalRef}
            className={`innovation-modal custom-modal ${isFullScreen ? 'fullscreen' : ''} ${small ? 'small-modal' : ''} ${position ? 'dragged' : ''}`}
            style={position && !isFullScreen ? {
                transform: 'none',
                left: `${position.x}px`,
                top: `${position.y}px`
            } : undefined}
        >
            <div className="modal-content">
                <div className="modal-header" onMouseDown={handleMouseDown} style={{ cursor: isFullScreen ? 'default' : 'move' }}>
                    <span id="modalTitle">{data.title}</span>
                    <div>
                        <span
                            className="modalclose pointer fas fa-times"
                            onClick={onClose}
                        ></span>
                    </div>
                </div>
                <div className="modal-body">
                    {data.hideDefaultContent ? (
                        <div className="content-container">
                            {data.content}
                        </div>
                    ) : (
                        <div className="content-container">
                            <p><strong>Description :</strong> {data.description ? data.description : "No description available"}</p>
                            <p><strong>What problem does it solve? :</strong> {data.definition ? data.definition : "No definition available"}</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ModalInnovation;
